import Container = PIXI.Container;
import TextStyle = PIXI.TextStyle;
import { createSprite, translate } from '../../utils/GameEngine';
import { TextStyles } from '../../utils/TextStyles';
import { Events } from '../Events';

export class ScoreLabel extends Container {
    private label: PIXI.Text;
    private background: PIXI.Sprite;
    private icon: PIXI.Sprite;
    private clicked: number = 0;

    constructor(score: number, parent?: Container) {
        super();
        this.drawLayout(score);
        if (parent) {
            parent.addChild(this);
        }
    }

    private drawLayout(score: number): void {
        this.background = createSprite('yellow_btn_large@2x', this);
        this.icon = createSprite('score_icon@2x', this);
        this.icon.anchor.set(0.5, 0.5);
        this.icon.position.set(this.icon.width / 2, this.background.height / 2 - 6);
        const style: TextStyle = TextStyles.uiText.clone();
        style.fontSize = '25px';
        style.wordWrap = false;
        this.label = new PIXI.Text(translate('Score', true) + ' ' + score, style);
        this.addChild(this.label);
        this.label.anchor.set(0, 0.5);
        this.label.position.set(this.icon.width * 1.3, this.background.height / 2 - 4);
        this.pivot.set(this.width / 2, this.height / 2);
        this.interactive = true;
        this.on('pointerdown', this.onClicked.bind(this));
    }

    private onClicked(): void {
        this.clicked++;
        if (this.clicked === 5) {
            this.clicked = 0;
            dispatchEvent(new CustomEvent(Events.showCheatPopup));
        }
    }

    public updateScore(newScore: number): void {
        this.label.text = translate('Score', true) + ' ' + newScore;
        this.label.position.set(this.icon.width * 1.3, this.background.height / 2 - 4);
    }
}